import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap'; // @TODO: This module is only used for the slide-up menu when clicking on the username
import { MaterialModule } from '@app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxEchartsModule } from 'ngx-echarts';
import { WidgetsModule } from '@app/widgets/widget.module';
import { LegacyWidgetsModule } from '@app/legacy-widgets/legacy-widget.module';

/**
 * Unfortunately we need to also import the client conponents + keep AOT compilation
 */
import { paepae_CustomWidgetLayoutComponent } from './custom-widget-layout/custom-widget-layout.component';
import { paepae_FilterDrawerLayoutComponent } from './filter-drawer-layout/filter-drawer-layout.component';
import { paepae_MainLayoutComponent } from './main-layout/main-layout.component';
import { SharedModule } from '@app/@shared';
import { FilterPanelModule } from '@app/@shared/filter-panel/filter-panel.module';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule,
    NgbModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts'),
    }),
    WidgetsModule,
    LegacyWidgetsModule,
    SharedModule,
    FilterPanelModule,
  ],
  declarations: [paepae_MainLayoutComponent, paepae_FilterDrawerLayoutComponent, paepae_CustomWidgetLayoutComponent],
})
export class ClientPaepaeModule {}
